import { render, staticRenderFns } from "./DashPatients.vue?vue&type=template&id=6b8d64cd&scoped=true"
import script from "./DashPatients.vue?vue&type=script&lang=js"
export * from "./DashPatients.vue?vue&type=script&lang=js"
import style0 from "./DashPatients.vue?vue&type=style&index=0&id=6b8d64cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d64cd",
  null
  
)

export default component.exports